import { useLocation } from 'react-router-dom';

const useIsPageWithoutFooter = (): boolean => {
  const { pathname } = useLocation();

  return (
    pathname === '/calendar' ||
    pathname === '/calendar-migrated' ||
    pathname === '/owner/calendar' ||
    pathname === '/owner/calendar-migrated'
  );
};

export default useIsPageWithoutFooter;
